module.exports = __webpack_public_path__ + "static/media/3.76c41641.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/3.jpg
 ** module id = 667
 ** module chunks = 0
 **/